

import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import useGet from '../api/useGet';
import { GetTrialsMenuItems, GetTrialsMenuItemsResponse } from '@/api/dtos';

const getData = (response?: SWRResponse<GetTrialsMenuItemsResponse, GetTrialsMenuItemsResponse>) => response?.data?.tileInstitutionData;
const getError = (response?: SWRResponse<GetTrialsMenuItemsResponse, GetTrialsMenuItemsResponse>) => (response?.error ?? response?.data)?.responseStatus;


export const useMenuItems = (trialId?: number, institutionId?: string, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!trialId) {
            return undefined;
        }

        return () => {
            return new GetTrialsMenuItems({ trialId, institutionId });
        }
    }, [trialId]);

    return useGet(request, { getData, getError }, configuration);
}

export default useMenuItems;